// src/services/ScormFilesService.js

import httpExternal from "./httpExternalService";

const SCORM_API_URL = process.env.VUE_APP_SCORM_API_URL;
class ScormFilesService {
  async getAll(params) {
    const url = httpExternal.getUrlWithParams(
      `${SCORM_API_URL}/api/scorm/get`,
      params
    );
    return await httpExternal.get(url);
  }

  async getAllWithPagination(params) {
    const url = httpExternal.getUrlWithParams(
      `${SCORM_API_URL}/api/scorm/list`,
      params
    );
    return await httpExternal.get(url);
  }

  async remove(id) {
    const url = `${SCORM_API_URL}/api/scorm/delete/${id}`;
    return await httpExternal.delete(url);
  }

  async upload(file) {
    const url = `${SCORM_API_URL}/api/scorm/storeapi`;
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    return await httpExternal.post(url, formData, config);
  }
}

export default new ScormFilesService();
